import {useEffect, useState} from 'react';
import {styled} from "@mui/material/styles";
import {useSelector} from "react-redux";
import StarIcon from '@mui/icons-material/Star';
import { missingSkills } from '../../constants/missingSkills';

const SkillName = styled("span")`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`
const randomColors = [
    "#3AA6B9",
    "#9575DE",
    "#917FB3",
    "#E8A0BF",
    "#3A4F7A",
    "#F65A83",
    "#372948",
    "#B93160",
    "#446A46",
    "#524A4E",
    "#694E4E",
    "#7897AB"
]

const ChipWrapper = styled('span')`
    //   display: flex;
    // align-items: center;
    // box-shadow: #fefefefe 0px 0px 0px 1px;
    // border-radius: 10px;
    // gap: 10px;
    // font-weight: 600;
    // color: rgb(40, 59, 112);
    // font-size: 14px;
    // overflow: hidden;
    // padding: 10px 10px;
    // background: #c8cfe72b;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    box-shadow: rgba(254, 254, 254, 0.996) 0px 0px 0px 1px;
    border-radius: 10px;
    gap: 5px;
    font-weight: 600;
    font-size: 12px;
    overflow: hidden;
    padding: 5px;
    background: rgba(200, 207, 231, 0.17);
`;

const Vl = styled('div')`
    border-left: 2px solid rgb(40, 59, 112);
    height:22px;
`
// To get Icons Slug - https://github.com/simple-icons/simple-icons/blob/master/slugs.md

export default function SkillChipsV3({skillName, isFavourite, handleFavourite, shouldShowStar, experience, pointerEvents, className }) {
    const [isFavouriteLocal, setIsFavouriteLocal] = useState(false);
    const {skills = []} = useSelector((state) => {
        return {
            skills: state?.skills?.skills || [],
        }
    });
    const foundSkill = skills?.find(skill => skill.slug === skillName);
    const missingSkill = missingSkills?.find(skill => skill.slug === skillName);
    let avatarSrc  = null;
    if (missingSkill) {
        avatarSrc  = `${process.env.REACT_APP_GEEKIFY_SKILL_ICON_URL}/${(missingSkill?.icon || '').replace(/^\/+/, '')}.svg`
    } else {
        avatarSrc  = `${process.env.REACT_APP_ICON_URL}${foundSkill?.icon || ""}`;
    }

    const handleIsFavourite = () => {
        setIsFavouriteLocal(!isFavouriteLocal);
        if (handleFavourite) {
            handleFavourite(!isFavouriteLocal);
        }
    }

    useEffect(() => {
        setIsFavouriteLocal(isFavourite);
    }, [isFavourite])

    return (
        <>
        {
            foundSkill ?
                <ChipWrapper className={className || ""}>

                    {shouldShowStar ? <StarIcon style={{color: isFavouriteLocal ? "#ffe82f" : "#bfbfbf", cursor: "pointer", pointerEvents: pointerEvents ? pointerEvents : 'auto'}}
                                            onClick={() => handleIsFavourite()}/> : null}
                    {foundSkill?.icon ? <span style={{ width: "22px", height: "22px"}}>
                        <img alt={foundSkill?.name?.[0] || ""} src={avatarSrc} style={{ width: "22px", height: "22px"}} />
                    </span> : null}
                    <SkillName>
                        {foundSkill?.name}
                    </SkillName>
                    {experience ?
                        <>
                            <Vl/>
                            <span>
                                {experience > 10 ? `10+` : experience } {experience > 1 ? "Years" : "Year"}
                            </span>
                        </> : null}
                </ChipWrapper>
            : null
        }
        </>
    );
}
